import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "divide-y divide-gray-200" }
const _hoisted_4 = { class: "mt-6 grid grid-cols-4 gap-6" }
const _hoisted_5 = { class: "col-span-4" }
const _hoisted_6 = { class: "yt-preview text-center col-span-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "py-3 rounded-lg bg-orange-200 text-orange-700 text-sm font-medium"
}
const _hoisted_10 = { class: "py-3" }
const _hoisted_11 = { class: "bg-white" }
const _hoisted_12 = { class: "mx-auto py-8 sm:py-12" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mt-6 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 sm:gap-y-10 lg:grid-cols-3" }
const _hoisted_15 = { class: "relative group" }
const _hoisted_16 = { class: "aspect-w-16 aspect-h-9 rounded-lg overflow-hidden bg-gray-100 shadow-lg" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "mt-3" }
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = { class: "mt-3" }

import {onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    AddVideoReelRequest,
    GetVideoReelsRequest,
    GetVideoReelsResponse,
    MakeVideoReelPrimaryRequest,
    RemoveVideoReelRequest,
    VideoReelDTO,
} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import {Switch} from '@headlessui/vue';
import {JsonServiceClient} from "@servicestack/client";
import {trackEvent} from '@/shared';
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateProfileVideos',
  setup(__props) {

// @ts-ignore
let responseStatus = ref(null);
let newReel = ref({});
let reels: Ref<VideoReelDTO[]> = ref([]);

let updateSuccessful: Ref<Boolean> = ref(false);

onMounted(async () => {
    await getReels();
});

const getReels = async () => {
    client.credentials = "include";
    await client.get<GetVideoReelsResponse>(new GetVideoReelsRequest())
        .then(response => {
            reels.value = response.reels;
        });
}

const isSubmitting = ref(false);
const addVideoReel = async (response: any) => {
    isSubmitting.value = true;
    client.credentials = "include";
    await client.post<GetVideoReelsResponse>(new AddVideoReelRequest(newReel.value))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            newReel.value = {};
            reels.value = res.reels;
            
            trackEvent( 'profile_updated', {
                method: 'video_added'
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
}

const makeVideoReelPrimary = async (reel: VideoReelDTO) => {
    client.credentials = "include";
    await client.post<GetVideoReelsResponse>(new MakeVideoReelPrimaryRequest({
        videoReelId: reel.id
    }))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            reels.value = res.reels;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
}

const isDeleting = ref(false);
const deleteVideoReel = async (reel: VideoReelDTO) => {
    isDeleting.value = true;
    client.credentials = "include";
    await client.delete<GetVideoReelsResponse>(new RemoveVideoReelRequest({
        videoReelId: reel.id
    }))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            reels.value = res.reels;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isDeleting.value = false;
}

const validateAndPreviewReel = () => {
    console.log(newReel.value)
    let videoInfo = parseVideoUrl(newReel.value.url);
    if (videoInfo) {
        if (videoInfo.provider === "youtube")
            validateAndPreviewYoutubeReel(videoInfo);
        if (videoInfo.provider === "vimeo")
            validateAndPreviewVimeoReel(videoInfo);
    } else
        onInvalidLink();
}

const parseVideoUrl = (url: string) => {
    let re =
        /https?:\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be))\/(video\/|embed\/|watch\?v=)?([A-Za-z0-9._%-]*)(\&\S+)?/;
    let str = url;

    let m = re.exec(str);

    if (m === null)
        return null;

    let match = {
        provider: "",
        url: m[2] || "",
        id: m[5] || ""
    };

    if (match.url === 'youtube.com' || match.url === 'youtu.be') {
        match.provider = "youtube";
        return match;
    } else if (match.url === 'vimeo.com') {
        match.provider = "vimeo";
        return match;
    }

    return null;
}

const validateAndPreviewYoutubeReel = async (params: any) => {
    let jsClient = new JsonServiceClient();
    jsClient.credentials = "same-origin";
    jsClient.headers = new Headers();
    await jsClient.get(`https://www.googleapis.com/youtube/v3/videos?key=AIzaSyAuUB_0MxBqVhZSJsadJ_bYOwXqQsNiWfE&part=id,snippet&fields=items/id,items/snippet/thumbnails/medium&id=${params.id}`,)
        .then((response: any) => {
            if (response.items === null || response.items.length < 1) {
                onInvalidLink();
                return;
            }
            newReel.value = {
                isValid: true,
                embedUrl: `//www.youtube.com/embed/${response.items[0].id}?rel=0`,
                provider: "youtube",
                uniqueId: response.items[0].id,
                thumbnailUrl: response.items[0].snippet.thumbnails.medium.url,
                url: `https://www.youtube.com/watch?v=${response.items[0].id}`
            };
        })
        .catch(e => {
            onInvalidLink();
        });
}

const validateAndPreviewVimeoReel = async (params: any) => {
    let jsClient = new JsonServiceClient();
    jsClient.credentials = "same-origin";
    jsClient.headers = new Headers();
    await jsClient.get(`https://vimeo.com/api/v2/video/${params.id}.json`)
        .then((response: any) => {
            console.log(response[0]);
            newReel.value = {
                isValid: true,
                embedUrl: `//player.vimeo.com/video/${response[0].id}?rel=0`,
                provider: "vimeo",
                uniqueId: response[0].id,
                thumbnailUrl: response[0].thumbnail_medium,
                url: response[0].url
            };
        })
        .catch(e => {
            onInvalidLink();
        });
}

const onInvalidLink = () => {
    newReel.isValid = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", null, [
        _createVNode(ErrorSummary, { "response-status": _unref(responseStatus) }, null, 8, ["response-status"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "reel-link"
                }, "Add a link to a video from YouTube or Vimeo", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "reel-link",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(newReel).url) = $event)),
                  class: "mt-1 block w-full border border-clay-500 rounded-md shadow-sm py-2 px-3 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                  name: "reel-link",
                  onInput: validateAndPreviewReel,
                  onChange: _withModifiers(validateAndPreviewReel, ["prevent"])
                }, null, 544), [
                  [_vModelText, _unref(newReel).url]
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mt-2 text-sm text-clay-800" }, "e.g. https://www.youtube.com/watch?v=SKe1i0Jb18w ", -1))
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_unref(newReel)?.isValid)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                      _createElementVNode("iframe", {
                        src: _unref(newReel).embedUrl,
                        allowfullscreen: "",
                        frameborder: "0",
                        height: "315",
                        width: "100%"
                      }, null, 8, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(newReel)?.url?.length > 0 && !_unref(newReel)?.isValid)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_9, _cache[3] || (_cache[3] = [
                      _createElementVNode("span", { class: "alert alert-danger" }, "Invalid Youtube or Vimeo link.", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(SaButton, {
                onClick: _withModifiers(addVideoReel, ["prevent"]),
                loading: isSubmitting.value,
                variant: "primary"
              }, {
                loading: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Adding... ")
                ])),
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createTextVNode(" Add "))
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "space-x-4" }, [
              _createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Your Reels")
            ], -1)),
            (_unref(reels)?.length < 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, " You haven't added any videos yet. "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reels), (reel) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      href: reel.url,
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        src: reel.thumbnailUrl,
                        class: "object-center object-cover min-w-full",
                        alt: "Video thumbnail"
                      }, null, 8, _hoisted_18)
                    ], 8, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "flex-grow flex flex-col" }, [
                        _createElementVNode("span", {
                          id: "primaryHeadshot-label",
                          class: "text-sm font-medium text-gray-900"
                        }, "Primary")
                      ], -1)),
                      _createVNode(_unref(Switch), {
                        modelValue: reel.isPrimary,
                        "onUpdate:modelValue": ($event: any) => ((reel.isPrimary) = $event),
                        class: _normalizeClass([reel.isPrimary ? 'bg-clay-600' : 'bg-gray-200', 'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-clay-500']),
                        onClick: _withModifiers(($event: any) => (makeVideoReelPrimary(reel)), ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "sr-only" }, "Primary", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass([reel.isPrimary ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-sm transform ring-0 transition ease-in-out duration-200']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "class", "onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(SaButton, {
                      onClick: _withModifiers(($event: any) => (deleteVideoReel(reel)), ["prevent"]),
                      loading: isDeleting.value,
                      variant: "ghost"
                    }, {
                      loading: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" Deleting... ")
                      ])),
                      default: _withCtx(() => [
                        _cache[9] || (_cache[9] = _createTextVNode(" Delete "))
                      ]),
                      _: 2
                    }, 1032, ["onClick", "loading"])
                  ])
                ]))
              }), 256))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: _unref(updateSuccessful),
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})